var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative"},[_c('figure',{class:{ 'portrait': _vm.isPortrait }},[_c('img',{attrs:{"src":_vm.src},on:{"click":_vm.handleClick}}),_c('figcaption',[_vm._v(_vm._s(_vm.caption))])])])}
var staticRenderFns = []

export { render, staticRenderFns }